import moment from 'moment';
import _ from 'lodash';

import { handleErrorException, loading, success } from 'State/actions';
import { ApplicationFieldEnum as ApplicationFields } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_SERVER } from 'Common/Constants';

import * as types from './types';

export const getExistingAppComparison = (appId, householdSystemId) => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(
      loading(
        types.DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_LOADING,
        true
      )
    );
    const res = await MPWWebApi.getGeneric(
      `/IncomingApplication/${appId}/CompareToExistingApplication/${householdSystemId}`
    );

    dispatch(
      success(
        types.DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_SUCCESS,
        res.data.Data
      )
    );
  } catch (ex) {
    dispatch(
      handleErrorException(
        ex,
        types.DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_ERROR,
        {
          Title: 'Error',
          Message: 'Failed to load duplicate application comparison.',
        }
      )
    );
  } finally {
    dispatch(
      loading(
        types.DUPLICATE_APPS_GET_EXISTING_APPLICATION_COMPARISON_LOADING,
        false
      )
    );
  }
};

export const clearErrors = () => ({
  type: types.DUPLICATE_APPS_CLEAR_ERRORS,
});

export const startNewApplication = (mergedApplication) => {
  const copy = _.cloneDeep(mergedApplication);
  const currentDate = moment().format(DATE_FORMAT_FOR_SERVER);

  copy[ApplicationFields.ApplicationInformation][
    ApplicationFields.ApplicationDate
  ] = currentDate;
  copy[ApplicationFields.ApplicationInformation][ApplicationFields.Id] = null;
  copy[ApplicationFields.ApplicationInformation][
    ApplicationFields.FamilyNumber
  ] = 0;
  copy[ApplicationFields.Students] = copy[ApplicationFields.Students].map(
    (s) => ({
      ...s,
      [ApplicationFields.EffectiveDate]: currentDate,
    })
  );

  return {
    type: types.DUPLICATE_APPS_START_NEW_APPLICATION,
    payload: copy,
  };
};

export const editApplication = (mergedApplication) => ({
  type: types.DUPLICATE_APPS_EDIT_APPLICATION,
  payload: mergedApplication,
});

export const getDuplicateApplications = (scannedAppId) => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  try {
    dispatch(loading(types.DUPLICATE_APPS_GET_DUPLICATE_APPS_LOADING, true));
    const res = await MPWWebApi.getGeneric(
      `IncomingApplication/DuplicateApplications/${scannedAppId}`
    );
    dispatch(
      success(types.DUPLICATE_APPS_GET_DUPLICATE_APPS_SUCCESS, res.data.Data)
    );
  } catch (ex) {
    dispatch(
      handleErrorException(ex, types.DUPLICATE_APPS_GET_DUPLICATE_APPS_ERROR, {
        Title: 'Error',
        Message: 'Failed to load duplicate applications.',
      })
    );
  } finally {
    dispatch(loading(types.DUPLICATE_APPS_GET_DUPLICATE_APPS_LOADING, false));
  }
};



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/state/duplicateapps/actions.js